import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cream%20and%20soft%20amber%20abstract%20geometric%20background%20with%20gentle%20curves%20and%20organic%20shapes%2C%20minimalist%20and%20modern%20style%2C%20light%20airy%20atmosphere%2C%20no%20text%2C%20clean%20design%2C%20subtle%20gradient%20from%20light%20cream%20to%20warm%20beige%2C%20abstract%20composition%20with%20soft%20flowing%20lines%20and%20circular%20elements&width=1600&height=900&seq=hero-bg-2024-01&orientation=landscape"
          alt="福利导航"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <i className="ri-sparkling-line text-accent-400 text-sm"></i>
          <span className="text-sm text-background-50 font-medium">每日更新 · 福利资源实时追踪</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-5">
          一站式福利资源
          <br />
          <span className="text-accent-300">聚合平台</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚全网优质福利资源，覆盖电商优惠、会员权益、生活补贴、政府福利等八大品类，
          帮助您快速找到最实用的福利入口，省时省钱，轻松享受各类专属权益。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/dianshang-youhui"
            className="px-6 py-3 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            浏览福利资源
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 rounded-md text-sm font-medium bg-background-50/15 text-background-50 hover:bg-background-50/25 border border-background-50/20 transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}